// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__38C60","rootSmall":"AddTileButton_rootSmall__1Hy7C"};